var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#D8D1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.677 15.415a3.688 3.688 0 01-3.413 2.296 3.694 3.694 0 01-3.694-3.694 3.683 3.683 0 013.684-3.684c1.409 0 2.63.793 3.256 1.951",
    stroke: "#604DBC",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.712 12.946l-2.016-.727 2.696-1.305-.68 2.032z",
    fill: "#604DBC"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjIyIiBoZWlnaHQ9IjIyIiByeD0iMTEiIGZpbGw9IiNEOEQxRkEiLz4KPHBhdGggZD0iTTE3LjY3NjYgMTUuNDE0OUMxNy4xMjM1IDE2Ljc2MSAxNS44MDg3IDE3LjcxMDYgMTQuMjY0MyAxNy43MTA2QzEyLjIxOTEgMTcuNzEwNiAxMC41NzAzIDE2LjA1MTQgMTAuNTcwMyAxNC4wMTY2QzEwLjU3MDMgMTEuOTgxNyAxMi4yMTkxIDEwLjMzMyAxNC4yNTM5IDEwLjMzM0MxNS42NjI2IDEwLjMzMyAxNi44ODM1IDExLjEyNjEgMTcuNTA5NiAxMi4yODQ0IiBzdHJva2U9IiM2MDREQkMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNMTcuNzEyNCAxMi45NDYxTDE1LjY5NjMgMTIuMjE5M0wxOC4zOTI1IDEwLjkxMzhMMTcuNzEyNCAxMi45NDYxWiIgZmlsbD0iIzYwNERCQyIvPgo8L3N2Zz4K";
export { SvgRefresh as ReactComponent };